import { PlansPlanMode } from '../../../api/types'
import {
  isIdealPlansFetchFailed,
  isIdealPlansLoading,
  useLumpsumPlansContext
} from '../../LumpsumPlansProvider'
import { PlansCategoryListSkeleton } from '../../lumpsum-ui-components/PlansCategoryListSkeleton'
import { IdealBlurredBody } from './IdealBlurredBody'
import { IdealCategoryList } from './IdealCategoryList'
import { IdealPlansListErrorState } from './IdealPlansListErrorState'

/** Rolled-out ideal body: locked (not Prime) or full list. */
export function LumpsumIdealBody() {
  const { idealData, idealPlansQuery } = useLumpsumPlansContext()

  if (isIdealPlansLoading(PlansPlanMode.IDEAL_PORTFOLIO, idealData != null, idealPlansQuery)) {
    return <PlansCategoryListSkeleton />
  }

  if (isIdealPlansFetchFailed(PlansPlanMode.IDEAL_PORTFOLIO, idealPlansQuery)) {
    return <IdealPlansListErrorState onRetry={idealPlansQuery.refetch} />
  }

  if (idealData?.isPlanSubscriptionEligible !== true) {
    return <IdealBlurredBody />
  }

  return <IdealCategoryList />
}
